module.exports = __webpack_public_path__ + "static/media/promotions-icon.7739234b.svg";